import { render, staticRenderFns } from "./ViewPatientVisitEdit.vue?vue&type=template&id=0bf76fb0&"
import script from "./ViewPatientVisitEdit.vue?vue&type=script&lang=js&"
export * from "./ViewPatientVisitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports